import { UrlMatcher } from '@angular/router';

export const archiveYearMatcher: UrlMatcher = (segments, group, route) => {
  const archiveYear = segments[0];
  if (!archiveYear) return null;

  const isArchiveRoute = /^\d{4}$/.test(archiveYear.path);
  if (!isArchiveRoute) return null;

  return {
    consumed: segments,
    posParams: {
      archiveYear,
    },
  };
};
